import * as React from 'react'
import { QueryResult } from 'react-apollo'

import GenericError from 'main/components/common/GenericError'
import Loader from 'main/components/common/Loader'
import Page from 'main/components/common/Page'
import { trackSchoolPageHit } from 'main/util/analytics'
import Content from './Content'
import { CTABar } from './CTA'
import { SchoolPage as SchoolPageData, SchoolPage_school, SchoolPageVariables } from './gql'

interface IProps {
  result: QueryResult<SchoolPageData, SchoolPageVariables>
}

export default function SchoolPage(props: IProps) {
  const {
    result: { data, loading, error },
  } = props
  const school = data ? data.school : null
  const eli = isEli(school)
  const director = school ? school.director : null
  const user = data ? data.user : null
  const availabilitySurvey = data ? data.availabilitySurvey : null

  React.useEffect(() => {
    if (school) {
      trackSchoolPageHit(school.id)
    }
  }, [school ? school.id : null])

  const [ctaSectionVisible, setCTASectionVisible] = React.useState<boolean>(true)

  return <Page headerBottomBar={headerBottomBar()}>{renderContent()}</Page>

  function headerBottomBar() {
    if (!school) return null
    if (ctaSectionVisible) return null

    return <CTABar school={school} />
  }

  function isEli(thisSchool: SchoolPage_school | null) {
    return getNetworkAbbreviations(thisSchool).includes('ELI')
  }

  function getNetworkAbbreviations(thisSchool: SchoolPage_school | null) {
    const networks = thisSchool ? thisSchool.networks : null
    if (networks) {
      return networks
        .map(network => {
          const options = JSON.parse(network?.whitelabelOptions)
          if ('NETWORK_ABBR' in options) {
            return options.NETWORK_ABBR
          }
          return null
        })
        .filter(n => n)
    }
    return []
  }

  function renderContent() {
    if (loading) return <Loader />
    if (error || !director || !school) {
      return <GenericError heading={'Sorry, something unexpected happened. (2)'} />
    }

    return (
      <Content
        availabilitySurvey={availabilitySurvey}
        director={director}
        school={school}
        user={user}
        onChangeCTASectionVisible={setCTASectionVisible}
        eli={eli}
      />
    )
  }
}
